const config = {
  client: 1,
  title: "外贸线索与SEO管理系统",
  version: "0.0.1",
};

export default config;
